module.exports = __webpack_public_path__ + "static/media/registry.a3ea197f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/website/manage-redesign/registry.svg
// module id = 961
// module chunks = 71